"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartDialogMessageType = void 0;
var StartDialogMessageType;
(function (StartDialogMessageType) {
    StartDialogMessageType["CloseStartDialog"] = "CloseStartDialog";
    StartDialogMessageType["DisplayStartDialog"] = "DisplayStartDialog";
    StartDialogMessageType["ErrorOnSetLanguage"] = "ErrorOnSetLanguage";
    StartDialogMessageType["Initialize"] = "Initialize";
    StartDialogMessageType["Logout"] = "Logout";
    StartDialogMessageType["OpenStartDialog"] = "OpenStartDialog";
    StartDialogMessageType["ResolveDisplayStartDialog"] = "ResolveDisplayStartDialog";
    StartDialogMessageType["ResolveInitialize"] = "ResolveInitialize";
    StartDialogMessageType["ResolveSetLanguage"] = "ResolveSetLanguage";
    StartDialogMessageType["StartProcess"] = "StartProcess";
    StartDialogMessageType["UpdateIdentity"] = "UpdateIdentity";
    StartDialogMessageType["UpdateLanguage"] = "UpdateLanguage";
    StartDialogMessageType["TranscendentError"] = "TranscendentError";
})(StartDialogMessageType = exports.StartDialogMessageType || (exports.StartDialogMessageType = {}));
